import { GridDataResult } from "@progress/kendo-angular-grid";

export class NGridPagedData<TGridViewModel> implements GridDataResult {
    data: TGridViewModel[];
    total: number;
}
